import React, { memo } from 'react';
import MypageReturn from '../molecules/MypageReturn';
import Paragraph from '../molecules/Paragraph';

interface Props {
  opened_mypage: boolean;
  is_staff: boolean;
}

// KWANKGM03030_事前審査申込入力（受付完了）フッタボタン
const FooterPreExaminationApplicationInputComplete: React.FC<Props> = ({
  opened_mypage,
  is_staff,
}) => {
  return (
    <>
      {opened_mypage ? (
        <MypageReturn is_staff={is_staff} />
      ) : (
        <Paragraph
          label="ウィンドウまたはタブを閉じて下さい。"
          is_paragraph={false}
          css_class={'text-center mt-3'}
        />
      )}
    </>
  );
};

export default memo(FooterPreExaminationApplicationInputComplete);
